import React from 'react'
import MaskedInput from 'react-text-mask'

import { validaCPF } from './common'

import {InlineIcon} from '@iconify/react'
// import checkIcon from '@iconify/icons-mdi/check-circle'
// import alertIcon from '@iconify/icons-mdi/alert-circle'


export default class CPFInput extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state={
      value: !!props.value ? props.value : '',
      isValid: false,
      hasChecked: false,
    }
  }

  componentDidMount() {
    this.doCheck(this.state.value)
  }

  doCheck = (value) => {
    // let value = !!e.target.value ? e.target.value : ''
    let cpf = value.replace(/\D/g, '')

    let isValid = validaCPF(value)
    let hasChecked = cpf.length === 11
    let rawValue = value.replace(/\./g, '').replace(/-/g, '').replace(/_/g, '')
    this.setState({value, isValid, hasChecked})
    if (!!this.props.onChange) {
      if (value.length === 0) {
        this.props.onChange('', '', true)
      } else {
        this.props.onChange(value, rawValue, isValid)
      }
    }
  }

  render() {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        // padding: '0px 4px',
      }}>
      <MaskedInput
        // style={{border: 0, flex: 0}}
        className={'form-text'}
        style={{textAlign: this.props.textAlign || 'left'}}
        mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
        showMask={false}
        placeholderChar={'_'}
        placeholder={this.props.placeholder || 'Digite seu CPF'}
        value={!!this.state.value ? this.state.value : ''}
        disabled={this.props.disabled}
        onChange={(e) => {
          this.doCheck(!!e.target.value ? e.target.value : '')
        }}
        onBlur={(e) => {
          e.preventDefault()
          !!this.props.onBlur && this.props.onBlur(e)
        }}
      />
      {this.props.showValidStatus && this.state.hasChecked && (
        this.state.isValid ? (
          <InlineIcon icon={"mdi:check"} width={20} style={{color: 'green'}} />
        ) : (
          <InlineIcon icon={"mdi:alert"} width={20} style={{color: 'red'}} />
        )
      )}
      </div>
    )
  }
}